<svg:g class="trace" [attr.transform]="trace.translate" [style.opacity]="trace.visible ? 1 : 0">

  <!-- TITLE -->
  <text class="title" [attr.y]="25" [style.fill]="trace.appearance.color" [style.opacity]="trace.title.visible ? 1 : 0">{{trace.title.text}}</text>

  <!-- SAMPLES -->
  <path id="ecgpath" [attr.d]="trace.samples" [style.stroke]="trace.appearance.color" [style.stroke-width]="trace.appearance.highlight ? 0.2 : 0.1"></path>

  <!-- FIDUCIAL POINTS -->
  <path *ngFor="let fiducialPoint of trace.fiducialPoints" [attr.d]="fiducialPoint.marker" [style.opacity]="trace.layout.ecgState.chartState.fiducialPointsVisible ? 1 : 0"></path>

  <g trace-step [title]="trace.step.title" [titleY]="trace.step.titleY" [path]="trace.step.path" [color]="trace.appearance.color" [highlight]="trace.appearance.highlight"></g>

  <rect id="bandOptions" class="optionsBand" [attr.x]="0" [attr.y]="trace.layout.context.leadHeight/2 - 1.5" [attr.width]="trace.layout.context.leadWidth" [attr.height]="3"></rect>

  <g trace-caliper *ngFor="let caliper of trace.calipers" [caliper]="caliper" (removeCaliper)="onRemoveCaliper($event)" (measuresChange)="onMeasuresChange($event)"></g>

</svg:g>
